"use client";

import React, { useState } from "react";

import { twMerge } from "@/utils/twMerge";

const tabs = [
  {
    id: "tab1",
    label: <>Do&nbsp;research with your lab</>,
    color: "blue",
  },
  {
    id: "tab2",
    label: "Write and share lectures",
    color: "emerald",
  },
  {
    id: "tab3",
    label: "Create team knowledge base",
    color: "yellow",
  },
  {
    id: "tab4",
    label: <>Publish your work or&nbsp;paper</>,
    color: "pink",
  },
];

function PreloadTailwindColors() {
  return (
    <div
      className="hidden md:bg-blue-50 md:border-blue-200 md:bg-yellow-50 md:border-yellow-200 md:bg-pink-50
      md:border-pink-200 md:bg-emerald-50 md:border-emerald-200"
    />
  );
}

export function AboutTabs() {
  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <div>
      <PreloadTailwindColors />
      <div className="flex gap-[16px] md:block sm:pt-[40px] sm:ml-[5px]">
        {tabs.map(({ id, label, color }) => (
          <React.Fragment key={id}>
            <button
              type="button"
              key={id}
              onClick={() => setActiveTab(id)}
              className={twMerge(
                "bg-gray-100 w-[25%] rounded-[20px] text-[34px] tracking-[-1.36px] leading-[90%] font-semibold text-left flex flex-col items-start",
                "pt-[27px] pl-[27px] pr-[17px] pb-[30px] border-[3px] border-gray-100",
                "xl:text-[30px] lg:p-[10px] lg:pb-[20px] lg:text-[25px]",
                "md:w-full md:pb-[367px] md:mb-[20px]",
                "sm:text-[38px] sm:tracking-[-1.52px] sm:pl-[17px] sm:pt-[17px] sm:rounded-[13px]",
                `md:bg-${color}-50 md:border-${color}-200`,
                activeTab === id && `bg-${color}-50 border-${color}-200`,
              )}
            >
              <img
                src={`https://storage.googleapis.com/corca-public/about/${id}-icon.svg`}
                width="34"
                height="34"
                alt=""
                className="mb-[11px]"
              />
              {label}
            </button>
            <div className="hidden md:block overflow-x-scroll no-scrollbar w-full absolute mt-[-372px] ml-[-30px]">
              <img
                src={`https://storage.googleapis.com/corca-public/about/${id}-small.png`}
                width="638"
                height="348"
                alt=""
                className="max-w-none md:block mx-[37px]"
              />
            </div>
          </React.Fragment>
        ))}
      </div>

      {tabs.map(({ id, color }) => (
        <div
          key={id}
          className={twMerge(
            "rounded-[20px] mt-[14px] hidden border-[3px] overflow-hidden",
            "md:hidden",
            activeTab === id && `block bg-${color}-50 border-${color}-200`,
          )}
        >
          <img
            src={`https://storage.googleapis.com/corca-public/about/${id}.png`}
            width="1239"
            height="580"
            alt=""
          />
        </div>
      ))}
    </div>
  );
}
